import { afterNextRender, Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToastCustomComponent } from './shared/widgets/toast/toast.component';
import { SpinnerComponent } from './shared/widgets/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from '../environments/environment';
import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';
import { CommonModule } from '@angular/common';
import { ScriptLoaderService } from './core/services/script-loader.service';
import { takeUntil } from 'rxjs';
import { Unsub } from './core/services/unsub.class';
import { TaxCompanionFloaterComponent } from './shared/widgets/tax-companion-floater/tax-companion-floater.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [
    RouterModule,
    ToastCustomComponent,
    SpinnerComponent,
    NgxSpinnerModule,
    AngularQueryDevtools,
    CommonModule,
    TaxCompanionFloaterComponent,
  ],
})
export class AppComponent extends Unsub implements OnInit {
  title = 'PayKaduna';
  isProduction = environment.production;

  constructor(private router: Router) {
    super();
    afterNextRender(() => {
      this.scriptLoader
        .loadScript(environment.remitaInlineUrl)
        .then(() => {
          // Access the global variable and function once the script has loaded
          console.log('Remita loaded');
        })
        .catch((error) => {
          console.log('error :>> ', error);
          console.error('Error loading remita:', error);
        });
      this.scriptLoader
        .loadScript(environment.interswitchInlineUrl)
        .then(() => {
          // Access the global variable and function once the script has loaded
          console.log('Interswitch loaded');
        })
        .catch((error) => {
          console.log('error :>> ', error);
          console.error('Error loading interswitch:', error);
        });

      this.router.events
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((event) => {
          if (event instanceof NavigationEnd) {
            if (!!document.querySelector('nz-content')) {
              (document.querySelector('nz-content') as HTMLElement).scrollTop =
                0;
            }
          }
        });
    });

    this.router.errorHandler = (error) => {
      console.error('Router error:', error);
    };
  }

  scriptLoader = inject(ScriptLoaderService);

  ngOnInit(): void {
    // Start all routes scroll position from top of page
  }
}
